import { THEMES } from './themes';

export const THEME = {
  [THEMES.dark]: {},
  [THEMES.light]: {},
};

/**
 * Values from the theme's JSON that are used only in-memory.
 */
export enum ThemeMemoryOnlyValues {
  mapLandColor = 'map-land-color',
  mapOutlineColor = 'map-outline-color',
  mapOnHover = 'map-on-hover',
  mapKpiCircle = 'map-kpi-circle',
  mapKpiLabel = 'map-kpi-label',
  mapCountryColor = 'map-country-color',
  mapRegionColors = 'map-region-colors',
  chartLineBackgroundColors = 'chart-line-background-colors',
  chartBarWithLineLineColor = 'chart-barline-line-color',
  chartColors = 'chart-colors',
  chartRadarBackgroundColors = 'chart-radar-background-colors',
  chartRadarAxisColor = 'chart-radar-axis-color',
  averageLineColor = 'average-line-color',
  averageLineColorLabel = 'average-line-color-label',
  averageLineColorLabelText = 'average-line-color-label-text',
  Opacity = 'opacity',
}

/**
 * Values from the theme's JSON that are used both in CSS and in-memory.
 */
export enum ThemeMemoryAndCssValues {
  textPrimaryColor = 'text-primary-color',
  textSecondaryColor = 'text-secondary-color',
  boxContrastBackgroundColor = 'box-contrast-background-color',
  boxLandingPageTextColor = 'box-landing-page-text-color',
  menuOpacity = 'menu-opacity',
  embeddedBackground = 'embedded-background',
  chartTreemapTextColor = 'chart-treemap-text-color',
  logoWidth = 'logo-width',
}

/**
 * All values from the theme's JSON that are used in memory (and some in CSS).
 */
export const ThemeMemoryValues = {
  ...ThemeMemoryOnlyValues,
  ...ThemeMemoryAndCssValues,
};

export const SUBJECT_AREA_PREVIEWS = {
  dashboard: {
    [THEMES.dark]: 'assets/img/subject-area-previews/custom-visuals-dark.png',
    [THEMES.light]: 'assets/img/subject-area-previews/custom-visuals-light.png',
  },
};

export const THEME_ICONS = {
  [THEMES.dark]: {
    icon: 'icon-light-theme',
  },
  [THEMES.light]: {
    icon: 'icon-dark-theme',
  },
};

export const SPEECH_ANIMATION = {
  [THEMES.dark]: 'assets/animations/voice-animation-dark.json',
  [THEMES.light]: 'assets/animations/voice-animation-light.json',
};
